import { cn } from "@/lib/utils";
import type { UserStatus, VerificationStatus, ModerationStatus, ReportStatus } from "@/admin/types/admin";
import {
  USER_STATUS_LABELS,
  VERIFICATION_STATUS_LABELS,
  MODERATION_STATUS_LABELS,
  REPORT_STATUS_LABELS,
} from "@/admin/types/admin";

type StatusType = UserStatus | VerificationStatus | ModerationStatus | ReportStatus;

const STATUS_COLORS: Record<string, string> = {
  // UserStatus
  active: "bg-green-100 text-green-800",
  suspended: "bg-yellow-100 text-yellow-800",
  banned: "bg-red-100 text-red-800",
  deleted: "bg-gray-100 text-gray-500",
  // VerificationStatus
  notRequested: "bg-gray-100 text-gray-600",
  pending: "bg-blue-100 text-blue-800",
  verified: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
  // ModerationStatus
  underReview: "bg-yellow-100 text-yellow-800",
  hidden: "bg-orange-100 text-orange-800",
  removed: "bg-red-100 text-red-800",
  // ReportStatus
  open: "bg-red-100 text-red-800",
  inProgress: "bg-blue-100 text-blue-800",
  resolved: "bg-green-100 text-green-800",
  dismissed: "bg-gray-100 text-gray-600",
};

const ALL_LABELS: Record<string, string> = {
  ...USER_STATUS_LABELS,
  ...VERIFICATION_STATUS_LABELS,
  ...MODERATION_STATUS_LABELS,
  ...REPORT_STATUS_LABELS,
};

interface Props {
  status: StatusType;
  className?: string;
}

export function AdminStatusBadge({ status, className }: Props) {
  const color = STATUS_COLORS[status] ?? "bg-gray-100 text-gray-600";
  const label = ALL_LABELS[status] ?? status;

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        color,
        className
      )}
    >
      {label}
    </span>
  );
}
